module.exports = __webpack_public_path__ + "img/af719af.png";